export default class Testimonials {

  constructor(el) {

    this.$el = el;
    this.$swiper = this.$el.querySelector('.swiper');
    this.swiper = this.initSwiper();

  }

  initSwiper() {
    let swiper = new Swiper(this.$swiper, {
      navigation: {
        nextEl: this.$swiper.querySelector(".swiper-button-next"),
        prevEl: this.$swiper.querySelector(".swiper-button-prev"),
      },
      pagination: {
        el: this.$swiper.querySelector(".swiper-pagination"),
        dynamicBullets: true,
      },
      speed: 600,
      spaceBetween: 0,
      height: "auto"
    });

    return swiper;
  }
}
